class Magnify {
  constructor() {

    this.ZOOM_RATIO = 2
    this.OVERLAY_CLASS = "product__image product__image--magnify";

    this.enableZoomOnHover();
  }

  enableZoomOnHover() {
    const images = document.querySelectorAll('.js-magnify .js-magnify-image');

    images.forEach(image => this.addImageListener(image));
  }

  addImageListener(image) {
    image.addEventListener("click", event => {
      this.createOverlay(image);
      this.addOverlayListeners(image);
      this.moveWithHover(image, event);
    });
  }

  addOverlayListeners(image) {
    this.overlay.addEventListener("click", () => this.overlay.remove());
    this.overlay.addEventListener("mousemove", event => this.moveWithHover(image, event));
    this.overlay.addEventListener("mouseleave", () => this.overlay.remove());
  }

  moveWithHover(image, event) {
    // calculate Mouse position
    const ratio = image.height / image.width;
    const container = event.target.getBoundingClientRect();
    const xPosition = event.clientX - container.left;
    const yPosition = event.clientY - container.top;
    const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
    const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

    // Determine what to show in the frame
    this.overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
    this.overlay.style.backgroundSize = `${image.width * this.ZOOM_RATIO}px`;
  }

  // create a container and set the full-size image as its background
  createOverlay(image) {
    const overlayImage = document.createElement('img');

    overlayImage.setAttribute('src', `${image.dataset.src}`);

    this.wrapper = image.closest(".js-magnify");
    this.overlay = document.createElement('div');

    this.prepareOverlay(this.overlay, overlayImage);

    image.style.opacity = '50%';

    this.toggleLoadingSpinner();
    this.addOverlayImageListener(overlayImage, image);
  }

  addOverlayImageListener(overlayImage, image) {
    overlayImage.addEventListener("load", () => {
      this.toggleLoadingSpinner();

      this.wrapper.appendChild(this.overlay);

      image.style.opacity = '100%';
    });
  }

  prepareOverlay(overlay, image) {
    overlay.setAttribute('class', this.OVERLAY_CLASS);
    overlay.setAttribute('aria-hidden', 'true');

    overlay.style.backgroundImage = `url('${image.src}')`;
  }

  toggleLoadingSpinner() {
    const loadingSpinner = this.wrapper.querySelector(".loader")

    loadingSpinner.classList.toggle('loader--active');
  }
}

new Magnify();